import { Paper } from '@mantine/core';
import { type PropsWithChildren } from 'react';

export const CustomPaper = ({ children }: PropsWithChildren) => {
  return (
    <Paper
      className="p-12 w-[30rem] mx-auto max-sm:w-[95%] max-sm:p-5"
      shadow="md"
    >
      {children}
    </Paper>
  );
};
